import { createOrderSearchCriteria, updateOrderSearchCriteria } from '@/lib/Orders/Search';

export function createOrderSearchStore() {
    return {
        namespaced: true,

        state: {
            /**
             * This is the search criteria used for the last search that was performed.
             * this.results should also be populated in this case.
             *
             * @type {OrderSearchCriteria|null}
             */
            searchCriteria: null,

            /**
             * These are the results of the last search that was performed.
             * this.searchCriteria should also be populated in this case.
             *
             * @type {OrderSearchResults|null}
             */
            results: null,

            /**
             * Are the cached results still valid?
             * This means do we know the data has changed since the results were loaded,
             * in a way that would significantly affect what's shown to the user.
             * For example, if you use a redeem button on an order details page, and there
             * is a "redeem session" button visible in the results list we should update
             * the data when returning to the results so known-stale information is not shown.
             */
            resultsValid: true,

            currentPage: 1,

            pageSize: 10,
        },
        mutations: {
            clear(state) {
                state.searchCriteria = null;
                state.results = null;
                state.resultsValid = true;
            },

            /**
             * @param {{}} state
             * @param {{searchCriteria: OrderSearchCriteria, results:OrderSearchResults}|null} data
             */
            setResults(state, data) {
                const { searchCriteria, results } = data || {};
                state.searchCriteria = searchCriteria || null;
                state.results = results || null;

                state.resultsValid = true;
            },

            setResultsValid(state, value) {
                state.resultsValid = value;
            },

            setCurrentPage(state, page) {
                state.currentPage = page;
            },
        },
        actions: {
            /**
             * @param context
             * @param {SessionWithEvent} sessionWithEvent
             */
            setupSearchForSession(context, sessionWithEvent) {
                context.commit('clear');

                const searchCriteria = createOrderSearchCriteria();
                searchCriteria.sessionWithEvent = sessionWithEvent;
                updateOrderSearchCriteria(searchCriteria);

                context.commit('setResults', { searchCriteria, results: null });
            },
        },
    };
}
